import { render } from "./BandeauHeader.vue?vue&type=template&id=26ebc2fc&ts=true"
import script from "./BandeauHeader.vue?vue&type=script&lang=ts"
export * from "./BandeauHeader.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod/app/releases/1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__